import { fetchWelcomeTextInboxCallerDetails } from './fetchWelcomeTextInboxCallerDetails';
import { fetchWelcomeTextInboxCallers } from './fetchWelcomeTextInboxCallers';
import { markWelcomeTextAsRead } from './markWelcomeTextAsRead';

export const welcomeTextInboxCallerService = {
  fetchWelcomeTextInboxCallerDetails,
  fetchWelcomeTextInboxCallers,
  markWelcomeTextAsRead,
};
